var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Drawer',{attrs:{"size":"max-w-xl"}},[_c(_vm.status,{tag:"component",attrs:{"details":_vm.details},on:{"cancel":_vm.cancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }